import { useLang } from "../../context/langProvider";
import LogoFictif from "../LogoFictif"
import "./styles.css"
const CardPrestataire = ({entreprise}) => {
    const { t } = useLang();
    
    return (
        <div className="card-presta">
            <div className="card-presta-header">
                <h3>{entreprise.name}</h3>
                <LogoFictif name={entreprise.name}/> 
                <p className="ville">PARIS</p>
                <p className="description">{entreprise.description}</p>
            </div>
            
            <div className="container-card-presta">
                
                <div className="container-buttons-presta">
                    <button>{t("show-profile")}</button>
                    <button>{t("ask-devis")}</button>
                </div>
                
            </div>

        </div>
    )
}
export default CardPrestataire